import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { APP_CONFIG, AppConfig } from "app/app.config";
import { LocaleService } from "app/shared/services/locale/locale.service";

/** Sends the selected portal language to API endpoints that can localize output. */
export const httpLanguageInterceptor: HttpInterceptorFn = (request, next) => {
  const config = inject<AppConfig>(APP_CONFIG);
  const apiOrigin = config.ApiOrigin.replace(/\/$/, "");

  if (!apiOrigin || !request.url.startsWith(`${apiOrigin}/`)) {
    return next(request);
  }

  const locale = inject(LocaleService).currentLocale;
  return next(
    request.clone({
      setHeaders: { "Accept-Language": locale }
    })
  );
};
